import type { ProgressPoint } from '@core/base/interfaces/progressBar.interface';

export function resolveQuizPoints(steps: number): ProgressPoint[] {
  const stepWidth = steps > 0 ? 100 / steps : 0;

  return Array.from({ length: steps + 1 }, (_, index) => ({
    icon: 'checked',
    activeFrom: stepWidth * index,
  }));
}
